<template lang="pug">
.content-center
  .bets-wrap
    .headline-bar
      .d-flex.align-items-center {{ $t("ui.result") }}
    ul.d-flex
      li.flex-grow-1
        a(:class="{'active': selected == 'default'}" @click="goTab('default')") {{ $t("ui.result") }}
      li.flex-grow-1
        a(:class="{'active': selected == 'OR'}" @click="goTab('OR')") {{ $t("ui.outright") }}
  .filter-result-group
    .filter-result 
      .input-group
        date-picker.form-control.datepicker(v-model="resultDate" :config="locale" @input="refreshResult()")
        .input-group-append
          span.input-group-text
            i.fas.fa-calendar-alt
      .btn-result-group
        button.btn-result(
          type='button' 
          :class="{ 'text-warning' : resultDate == $dayjs().subtract(12, 'hours').format('YYYY-MM-DD') }"
          @click="resultDate = $dayjs().subtract(12, 'hours').format('YYYY-MM-DD');"
        ) {{ $t("ui.today") }}
        button.btn-result(
          type='button' 
          :class="{ 'text-warning' : resultDate == $dayjs().subtract(36, 'hours').format('YYYY-MM-DD') }"
          @click="resultDate = $dayjs().subtract(36, 'hours').format('YYYY-MM-DD');"
        ) {{ $t("ui.yesterday") }}
    .result-dropdown-group
      .dropdown.mr-1
        .dropdown-btn#dropdown-resultsport(data-toggle='dropdown' aria-haspopup='true' aria-expanded='false')
          span {{ sports[resultSportFilterKey] }}
        ul.dropdown-menu(aria-labelledby='dropdown-resultsport')
          li
            a.dropdown-item(href="javascript:void(0);", @click="resultDDLOnChange(key, 'sports', false)", v-for="(item, key, index) in sports", :class="{ active: resultSportFilterKey == key }") {{ item }}
      .dropdown
        .dropdown-btn#dropdown-leagues(data-toggle='dropdown' aria-haspopup='true' aria-expanded='false')
          span {{ resultLeagueFilterKey == 0 ? $t('ui.all_league') : leagues[resultLeagueFilterKey] }}
        ul.dropdown-menu(aria-labelledby='dropdown-leagues')
          li
            a.dropdown-item(href="javascript:void(0);", @click="resultDDLOnChange(0, 'leagues', false)", :class="{ active: resultLeagueFilterKey == 0 }") {{ $t('ui.all_league') }}
          template(v-for="(item, key, index) in leagueEntries")
            li
              a.dropdown-item(href="javascript:void(0);" @click="resultDDLOnChange(parseInt(item[0]), 'leagues', true)" :class="{ active: resultLeagueFilterKey == parseInt(item[0]) }") {{ item[1] }}
  .pagepanel
    .page-group
      template(v-if="loading")
        .no-data
          .no-data-wrapper
            .loading-wrap
              .loading
                .block
                .block
                .block
              .text {{ $t("ui.loading") }}
      template(v-else)
        #result(v-if="resultList.length > 0")
          .bet-slip.result(v-for="(item, key, index) in groupResultList")
            .result-league-header.collapsed(:id="'heading-' + index" data-toggle='collapse' :data-target="'#collapse-' + index" :aria-expanded="index == 0 ? true : false" :aria-controls="'collapse-' + index")
              | {{ key }}
            .collapse(:id="'collapse-' + index" :aria-labelledby="'heading-' + index" data-parent="#result" :class="index == 0 ? 'show' : ''")
              .stake-info-wrapper(v-for="(info, indexChild) in item" :class="{ other: indexChild % 2 === 0, even: indexChild % 2 !== 0}")
                .stake-info
                  .betslip-match
                    .team-involved
                      span.team1 {{ getName(info, 0) }}
                      template(v-if="selected == 'default'")
                        .vs - VS -
                        span.team2 {{ getName(info, 1) }}
                .footer-slip.text-left
                  .payout-wrapper
                    template(v-if="selected == 'default'")
                      .left
                        | {{ $t("ui.first_half") }}:
                        span {{ info.half_home }}-{{ info.half_away }}
                      .right
                        | {{ $t("ui.final") }}:
                        span {{ info.final_home }}-{{ info.final_away }}
                    template(v-else)
                      .left(:class="info.outright_teamwin ? '' : 'text-danger'") {{ info.outright_teamwin ? $t('ui.win') : $t('ui.lose') }}
                  .bet-details
                    .row
                      .col-6.text-left {{ $t("ui.event") }}:
                      .col-6.text-right {{$dayjs(info.match_time).format("MM/DD/YYYY hh:mm A")}}
                    .row
                      .col-6.text-left {{ $t("ui.status") }}:
                      .col-6.text-right(v-if="selected == 'default'") {{ $t(getMatchStatus(info.half_match_status, info.match_status)) }}
                      .col-6.text-right(v-else) {{ $t(match[info.match_status]) }}
          .note-panel.mt-2.animated.fadeIn
            p.mb-1 {{ $t("ui.note") }}:
            ul.mb-0
              li {{ $t("message.gmt8") }}
        template(v-else)
          .no-data
            .no-data-wrapper
              img(src='/images/no_data.svg?v=12')
              span.text {{ $t("ui.no_record") }}
</template>


<script>
import config from "@/config";
import errors from "@/errors";
import service from "@/library/_xhr-result";
import naming from "@/library/_name";

export default {
  data() {
    return {
      loading: false,
      dt: null,
      selected: "default",
      leagues_distinct: [],
      outrightDateFrom: new Date(),
      outrightDateTo: new Date(),
      lotteryDate: new Date(),
      locale: {
        format: "YYYY-MM-DD",
        useCurrent: true,
        minDate: this.$dayjs(this.$dayjs().startOf("day").subtract(14, "days").format("YYYY-MM-DD", config.timeZone)).format("YYYY-MM-DD"),
        maxDate: this.$dayjs().format("YYYY-MM-DD", config.timeZone)
      },
      sortOption: [
        { text: "Bet Types", value: "betTypes" },
        { text: "All", value: "all" },
        { text: "Accepted", value: "accepted" },
        { text: "Pending", value: "pending" },
        { text: "Void", value: "void" }
      ],
      resultList: [],
      resultSportFilterKey: 1,
      resultLeagueFilterKey: 0,
      outrightList: [],
      outrightSportFilterKey: 1,
      outrightLeagueFilterKey: 0,
      lotteryList: [],
      lotteryFilterKey: {},
      feedback: {
        success: false,
        status: errors.session.invalidSession
      },
      currentPage: 1,
      totalPages: 0,
      bootstrapPaginationClasses: {
        ul: "pagination justify-content-center",
        li: "page-item",
        liActive: "active",
        liDisable: "disabled",
        button: "page-link",
        buttonActive: "active",
        buttonDisable: "disable"
      },
      paginationAnchorTexts: {
        first: "&laquo;",
        prev: "&lsaquo;",
        next: "&rsaquo;",
        last: "&raquo;"
      }
    };
  },
  computed: {
    groupResultList() {
      if (this.resultList.length > 0) {
        var tempList = this.resultList.reduce((r, v, i, a, k = v.league_name) => {
          (r[k] || (r[k] = [])).push(v);
          return r;
        }, {});

        var sortList = Object.keys(tempList).sort().reduce(function (result, key) {
          result[key] = tempList[key];
          return result;
        }, {});

        return sortList;
      }

      return [];
    },
    resultDate: {
      get() {
        if (this.dt) return this.dt;
        else return this.$dayjs().subtract("12", "hours").format("YYYY-MM-DD", config.timeZone);
      },
      set(value) {
        this.dt = value;
      }
    },
    sports() {
      return this.$store.state.layout.sports;
    },
    leagues: {
      get() {
        return this.leagues_distinct;
      },
      set(value) {
        this.leagues_distinct = value;
      }
    },
    leagueEntries() {
      var result = Object.entries(this.leagues).sort((a, b) => {
        if (a[1] < b[1]) return -1;
        if (a[1] > b[1]) return 1;
        return 0;
      });
      return result;
    },
    match() {
      return config.matchStatusName;
    },
    language() {
      return this.$store.getters.language;
    },
  },
  watch: {
    selected(val) {
      this.resultList = [];
      this.getResult(val === "OR");
    }
  },
  mounted() {
    this.getResult(false);
  },
  methods: {
    getName(e, mode) {
      switch(mode) {
        case 0: //home
          var r = e["home_name_" + this.language];
          if (r != null && r != "") {
            return r;
          }
          return e.home_name_en
        case 1: //away
          var r = e["away_name_" + this.language];
          if (r != null && r != "") {
            return r;
          }
          return e.away_name_en
        case 2: //league
          var r = e["name_" + this.language];
          if (r != null && r != "") {
            return r;
          }
          return e.league_name;
      }
    },
    goTab(e) {
      this.selected = e;
    },
    resultDDLOnChange(id, type) {
      // console.log(id, type, isOR, this.selected);
      if (type == "sports") this.resultSportFilterKey = id;
      else if (type == "leagues") this.resultLeagueFilterKey = id;

      var isOR = (this.selected == "OR")
      this.getResult(isOR);
    },
    getResult(isOR) {
      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        working_date_from: this.$dayjs(this.resultDate).format("MM/DD/YYYY"),
        working_date_to: this.$dayjs(this.resultDate).format("MM/DD/YYYY"),
        sports_type: this.resultSportFilterKey,
        league_id: this.resultLeagueFilterKey,
        is_outright: isOR
      };
      this.loading = true;
      service.getResult(json).then(
        result => {
          this.loading = false;
          if (result) {
            this.feedback.status = result.status;
            if (result.success == true) {
              this.resultList = result.data;
              // console.log(result.data);
              // get distinct league name to assign to dropdown..
              if (this.resultLeagueFilterKey == 0) {
                var unique = {};
                var distinct = {};
                result.data.forEach(x => {
                  if (!unique[x.league_id]) {
                    distinct[x.league_id] = x.league_name;
                    unique[x.league_id] = true;
                  }
                });
                this.leagues_distinct = distinct;
              }
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        },
        err => {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    refreshResult: function() {
      this.resultLeagueFilterKey = 0;
      this.getResult(this.selected === "OR");
    },
    getMatchStatus(ht, ft) {
      return naming.matchStatus(ht, ft);
    }
  }
};
</script>
